import { useQuery } from "@tanstack/react-query";

import type { OrganizationProfile } from "../core/domain/entities/organization-profile";
import { useOrganizationProfileApi } from "../hooks";

export const ORGANIZATION_PROFILE_QUERY_KEY = "organization/profile";

export const useQueryOrganizationProfile = () => {
  const { api } = useOrganizationProfileApi();

  return useQuery<OrganizationProfile>({
    queryKey: [ORGANIZATION_PROFILE_QUERY_KEY],
    queryFn: () => api.organizationProfile.getOrganizationProfile(),
  });
};
